import { inject } from "mobx-react";
import qs from "query-string";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { withRouter, type WithRouterProps } from "nvent-web/utils/withRouter";
import { compose } from "nvent-web/utils/compose";

import { UserStore } from "nvent-web/stores/User";
import { type BuildingType } from "nvent-web/types/BuildingType";
import { type SelectionGuideFormValues } from "nvent-web/types/SelectionGuideFormValues";

import RoomDetailsStepForm, {
  roomDetailsValidationSchema,
} from "../SelectionGuide/components/RoomDetailsStep/components/RoomDetailsStepForm/RoomDetailsStepForm";
import StepHeading from "../SelectionGuide/components/StepHeading/StepHeading";
import Redirect from "~/nvent-web/components/Redirect";

interface RoomDetailsStepInnerProps extends WithRouterProps {
  user: UserStore;
}

const emptyValues: SelectionGuideFormValues = {
  floorConstruction: null,
  floorFinish: null,
  area: null,
  installableArea: null,
  quickHeating: false,
  areaType: "dry",
};

export class RoomDetailsStepInner extends Component<RoomDetailsStepInnerProps> {
  cancelRoomEdit = () => {
    this.props.navigate("/selection-guide");
  };

  submit = (values: SelectionGuideFormValues) => {
    const { buildingType, countryCode, projectName } = qs.parse(
      window.location.search
    );

    this.props.navigate({
      pathname: `/selection-guide/recommendations`,
      search: qs.stringify({
        ...values,
        buildingType,
        projectName,
        countryCode,
      }),
    });
  };

  render() {
    const { buildingType, countryCode } = qs.parse(window.location.search);

    if (!buildingType) {
      return <Redirect to="/selection-guide/insulation" />;
    }

    const { user } = this.props;

    const queryValues = roomDetailsValidationSchema.cast(
      qs.parse(window.location.search)
    );

    const initialValues = {
      ...emptyValues,
      ...queryValues,
    };

    return (
      <>
        <StepHeading step={2} />
        <RoomDetailsStepForm
          isSubmitting={false}
          onCancel={this.cancelRoomEdit}
          cancelButtonText={<FormattedMessage id="actions.back" />}
          initialValues={initialValues}
          handleSubmit={this.submit}
          buildingType={buildingType as BuildingType}
          countryCode={
            (user.isReady
              ? user.companyAddress.countryCode
              : countryCode) as string
          }
        />
      </>
    );
  }
}

export const RoomDetailsStep = compose(
  withRouter,
  inject("user")
)(RoomDetailsStepInner);
